import React from "react";
import { useNavigate } from "react-router-dom";

function Navbar() {
  const navigate = useNavigate();

  return (
    <nav className="navbar navbar-dark bg-dark px-4">
      <span className="navbar-brand fw-bold">
        LINK JAPAN
      </span>

      <button
        className="btn btn-danger"
        onClick={() => navigate("/login")}
      >
        Login
      </button>
    </nav>
  );
}

export default Navbar;